import { CIcon } from '~/icons/types'

export const ciAngleLeft: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M8.47 12.53a.75.75 0 0 1 0-1.06l5-5a.75.75 0 1 1 1.06 1.06L10.06 12l4.47 4.47a.75.75 0 1 1-1.06 1.06l-5-5Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'angle-left',
  type: 'light'
}
